import Vue from 'vue'
import Router from 'vue-router'
import AllTaiwan from '@/components/AllTaiwan'
import EachRegion from '@/components/EachRegion'
import DoInLiao from '@/components/DoInLiao'
import ViewMaps from '@/components/ViewMaps'
import TestComponent from '@/components/TestComponent'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/AllTaiwan',
      name: 'AllTaiwan',
      component: AllTaiwan
    },
    {
      path: '/EachRegion/:Region_Eng',
      name: 'EachRegionWithRegion',
      component: EachRegion
    },
    {
      path: '/EachRegion',
      name: 'EachRegion',
      component: EachRegion
    },
    {
      path: '/ViewMaps',
      name: 'ViewMaps',
      component: ViewMaps
    },
    {
      path: '/Test',
      name: 'Test',
      component: TestComponent
    },
    { path: '*', redirect: '/ViewMaps' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js